export type TNativeMediaElementAudioSourceNode = MediaElementAudioSourceNode;
